import { Button } from "@Modules/common";
import { BUTTON_DESIGNS, REACTION_TYPES } from "@Utils";
import React from "react";
import { BsHeartFill } from "@react-icons/all-files/bs/BsHeartFill";
import { IoShareSocialSharp } from "@react-icons/all-files/io5/IoShareSocialSharp";
import { MdModeComment } from "@react-icons/all-files/md/MdModeComment";
import styles from "./BlogPostFooter.module.scss";
import { IBlogPostFooter } from "./IBlogPostFooter";

export const BlogPostFooter = ({
    openSharePopup,
    userReactionType,
    likeCount,
    onLikeClick,
    commentCount,
    commentClick,
}: IBlogPostFooter.IProps) => {
    return (
        <div className={styles.container}>
            <div className={styles.postStatsContainer}>
                <Button
                    design={BUTTON_DESIGNS.PLAIN_TEXT}
                    content={
                        <>
                            <BsHeartFill
                                color={
                                    userReactionType === REACTION_TYPES.LIKE
                                        ? "#ff6262"
                                        : "white"
                                }
                                size="1rem"
                            />
                            <div className={styles.statCount}>{likeCount}</div>
                        </>
                    }
                    className={styles.postStatContainer}
                    onClick={onLikeClick}
                />
                <Button
                    design={BUTTON_DESIGNS.PLAIN_TEXT}
                    content={
                        <>
                            <MdModeComment size="1rem" />
                            <div className={styles.statCount}>
                                {commentCount}
                            </div>
                        </>
                    }
                    className={styles.postStatContainer}
                    onClick={commentClick}
                />
                <Button
                    design={BUTTON_DESIGNS.PLAIN_TEXT}
                    content={<IoShareSocialSharp size="1rem" />}
                    className={styles.postStatContainer}
                    onClick={openSharePopup}
                />
            </div>
        </div>
    );
};

BlogPostFooter.defaultProps = {};
